const GamesCards = () => {
    const gamesCard = [
            {title: "Card Games",
            subTitle: "Card Games App",
            text: "My first bootcamp project was a Card Dealer JS Script.  Taking this code I have started creating simple games.  First up is Twenty One",
            image: "./images/cardGames21.png",
            imageAlt: "21 Card Game",
            linkUrl: "https://play-card-games.netlify.app",
            linkText: "Card Games App" },
            {title: "Card Games",
            subTitle: "Card Games GitHub",
            text: "GitHub Repo",
            image: "./images/Github_logo.png",
            imageAlt: "Github Repo",
            linkUrl: "https://github.com/DataSpot42/card-games-app",
            linkText: "Card Games Code" }            
        ]
return (gamesCard)
}
export default GamesCards